"use client";

import { cn } from "@/lib/utils";
import { usePathname, useRouter } from "next/navigation";
import { ROUTES } from "@/@core/constants/routes";
import { useSite } from "@/lib/hooks/site";
import { SitePages } from "@/@core/enums/pages.enum";
import { useMemo } from "react";
import { useTranslation } from "@/hooks/translationContext";

// Weblate keys rather than text: this list is built on import, where there is
// no translator, so the title is resolved inside the component instead.
const redirects = [
  {
    key: SitePages.about,
    path: ROUTES.ABOUT.ABOUT,
    titleKey: "sitemap-about-us-title",
  },
  // {
  //   path: ROUTES.ABOUT.HELP,
  //   titleKey: "...",
  // },
  {
    key: SitePages.contact,
    path: ROUTES.ABOUT.CONTACT,
    titleKey: "contact-page-title",
  },
];

export default function AboutUsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  const site = useSite();
  const router = useRouter();
  const pathname = usePathname();

  function redirectPage(path: string) {
    router.push(path);
  }

  const filteredPages = useMemo(() => {
    return redirects
      .filter((page) => {
        if (!page.key) return true;

        const pageValue = site.setting?.pages?.[page.key];

        return pageValue && pageValue !== "0";
      })
      .map((page) => ({ ...page, title: t(page.titleKey) }));
  }, [site.setting, t]);

  return (
    <main className="container">
      <header className="flex flex-wrap justify-between items-center py-6">
        <h1 className="text-[32px] font-bold text-primary">
          {filteredPages.find((redirect) => redirect.path == pathname)?.title}
        </h1>

        <div className="flex md:px-2 p-2 gap-2 rounded-full bg-gray flex-wrap md:justify-start justify-center">
          {filteredPages.map((redirect) => (
            <button
              role="button"
              key={redirect.path}
              className={cn(
                "py-2 px-4 text-base font-bold rounded-full duration-300",
                redirect.path == pathname ? "bg-white" : "text-assistant",
              )}
              onClick={() => redirectPage(redirect.path)}
            >
              {redirect.title}
            </button>
          ))}
        </div>
      </header>

      <div className="absolute left-0 w-full h-[1px] bg-gray-secondary"></div>
      {children}
    </main>
  );
}
